module.exports = __webpack_public_path__ + "static/media/diary.b91b7992.jpg";